import { ReferenceData } from '../../App/apiWrapper';
import { StringType } from '../../App/types';

export const getRefDataAttributeValue = (refData: ReferenceData, attributeName: string): StringType => {
  const attributes = refData.attributes || [];
  const attribute = attributes.find((attribute) => attribute.key === attributeName);
  return attribute ? attribute.value : null;
};
